import { ActionTypes } from "../actions/act_types"

export default (state = {}, action: any) => {
  switch (action.type) {
    case ActionTypes.UPDATE_SUPPLIER_PARAMETERS:
      return action.supplierParameters || {}
    default:
      return state
  }
}